import styled from "@emotion/styled";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

import { palette } from "~/theme";

const getColor = ({ textColor, theme }) => {
    return css`
        color: ${theme.palette[textColor]};
    `;
};

const FieldWrapper = styled.fieldset``;

const Input = styled.input`
    position: absolute;
    cursor: ${({ disabled }) => (disabled ? `not-allowed` : "pointer")};
`;

const RadioLabel = styled.label`
    ${getColor};
    font-size: 1.5rem;
    font-weight: 900;
    cursor: ${({ disabled }) => (disabled ? `not-allowed` : "pointer")};
    display: flex;

    &::before,
    &::after {
        content: "";
        border-radius: 50%;
        border: none;
    }

    &::before {
        height: 18px;
        width: 18px;
        background-color: ${({ theme }) => theme.palette.mediumGray};
        cursor: ${({ disabled }) => (disabled ? `not-allowed` : "pointer")};
        margin-right: 10px;
        padding: 10px;
        position: relative;
    }

    ${Input}:checked ~ & {
        &:after {
            position: absolute;
            top: 4px;
            left: 4px;
            height: 12px;
            width: 12px;
            background-color: ${({ theme }) => theme.palette.lightBlue};
        }
    }
`;

const RadioWrapper = styled.div`
    position: relative;
    margin-right: 20px;
    margin-bottom: 10px;
`;

const OptionsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Legend = styled.legend`
    margin-bottom: 5px;
`;

const StyledUserContent = styled.div`
    a {
        text-decoration: underline;
        color: ${({ theme }) => theme.palette.white};
    }
`;
const Radio = ({
    label,
    name,
    options,
    handleChange,
    value,
    required = false,
    disabled = false,
    labelPlacement = "",
    textColor = "darkBlue",
}) =>
    options?.length ? (
        <FieldWrapper>
            {labelPlacement !== "hidden_label" ? (
                <Legend>
                    {label}
                    {required ? "*" : ""}
                </Legend>
            ) : null}
            <OptionsWrapper>
                {options.map(({ text, value: optionValue }, index) => (
                    <RadioWrapper key={index}>
                        <Input
                            {...{ name, required, disabled }}
                            value={optionValue}
                            onChange={handleChange}
                            type="radio"
                            id={`${name}_${index}`}
                            checked={value === optionValue}
                        />

                        <RadioLabel
                            {...{ disabled, textColor }}
                            htmlFor={`${name}_${index}`}
                        >
                            <StyledUserContent>
                                {sanitizeAndParseHTML(text)}
                            </StyledUserContent>
                        </RadioLabel>
                    </RadioWrapper>
                ))}
            </OptionsWrapper>
        </FieldWrapper>
    ) : null;

Radio.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    labelPlacement: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ).isRequired,
    textColor: PropTypes.oneOf(Object.keys(palette)),
};

export default Radio;
